import { api } from '@/lib/api'
import type { UsuarioAdmin, UsuariosListResponse, UsuarioWritePayload } from './types'

export async function fetchUsuarios(params: {
  busca?: string
  perfil?: string
  ativo?: string
  page?: number
  por_pagina?: number
} = {}) {
  const qs = new URLSearchParams()
  if (params.busca) qs.set('busca', params.busca)
  if (params.perfil && params.perfil !== 'todos') qs.set('perfil', params.perfil)
  if (params.ativo !== undefined && params.ativo !== '') qs.set('ativo', params.ativo)
  if (params.page) qs.set('page', String(params.page))
  if (params.por_pagina) qs.set('por_pagina', String(params.por_pagina))
  const suffix = qs.toString() ? `?${qs}` : ''
  return api.get<UsuariosListResponse>(`/accounts/usuarios/${suffix}`)
}

export async function createUsuario(payload: UsuarioWritePayload) {
  const res = await api.post<{ sucesso?: boolean; dados: UsuarioAdmin; erros?: unknown }>(
    '/accounts/usuarios/',
    payload,
  )
  return res.dados
}

export async function updateUsuario(id: string, payload: Partial<UsuarioWritePayload>) {
  const res = await api.patch<{ sucesso?: boolean; dados: UsuarioAdmin; erros?: unknown }>(
    `/accounts/usuarios/${id}/`,
    payload,
  )
  return res.dados
}

export async function deleteUsuario(id: string) {
  return api.delete<{ sucesso?: boolean; mensagem?: string }>(`/accounts/usuarios/${id}/`)
}

export async function toggleUsuarioAtivo(id: string, isActive: boolean) {
  return updateUsuario(id, { is_active: isActive })
}
